import { API } from "../api/api";
import { APIRequest } from '../api/apiRequest';
import { APIResponse } from '../api/apiresponse';
import { HttpClientHandler } from '../../utils/httpclient/httpclient';
import { Logger, LogManager } from '../../utils/logger/logger';
import { BaseContext } from '../../utils/basecontext';
import { ResponseMapper } from '../../utils/httpclient/response/responsemapper';

export interface APIProcessor<T extends APIRequest, R extends APIResponse>
{
    execute(request: T): void;
    uploadProgress(uploadProgress: (percentage: number) => void): APIProcessor<T, R>;
    success(success: (r: R) => void): APIProcessor<T, R>;
    failure(failure: (r: R) => void): APIProcessor<T, R>;
}

export abstract class APIProcessorImpl<T extends APIRequest, R extends APIResponse> 
                                                 implements APIProcessor<T, R>, HttpClientHandler
{
    private logger: Logger = LogManager.getLogger(APIProcessorImpl.name);
    private onAPISuccess: (response: R) => void;
    private onAPIFailure: (response: R) => void;

    constructor(private applicationContext: BaseContext, private api: API<T>)
    {
        this.logger.log("APIProcessorImpl() invoked");
    }
    
    execute(request: T): void
    {
        this.api.generateRequest(this.processRequest(request), this).execute();
    }

    onUploadProgress(percentage: number): void {
       
    }

    uploadProgress(uploadProgress: (percentage: number) => void): APIProcessor<T, R> {
       
        return this;
    }

    success(success: (response: R) => void): APIProcessor<T, R> 
    {
       this.onAPISuccess = success;

       return this;
    }

    failure(failure: (response: R) => void): APIProcessor<T, R> 
    {
       this.onAPIFailure = failure;

       return this;
    }

    onSuccess(responseMapper: ResponseMapper): void 
    {
        this.logger.log("API Success invoked: Status Code: " + responseMapper.getStatusCode());
    }

    onFailure(responseMapper: ResponseMapper): void 
    {
        this.logger.log("API Failure invoked: Status Code: " + responseMapper.getStatusCode());
    }  

    protected getContext(): BaseContext
    {
        return this.applicationContext;
    }

    protected processRequest(request: T)
    {
        return request;
    }
    
    protected getAPISuccess(response: R): any
    {
        return this.onAPISuccess(response);
    }

    protected getAPIFailure(response: R): any
    {
        return this.onAPIFailure(response);
    }
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/processor/apiProcessor.ts